import { InstanceState } from "../../../instance-service/instance-state.service";
import { StateServices } from "../../../instance-service/i-state-services";


import { timerActions } from "./timer.actions";
import { TimerSelectors } from "./timer.selector";
import { TimerEffects } from "./timer.effects";
import { timerReducer } from "./timer.reducer";
import { TimerBlueprint } from "../timer";
import { Blueprint } from "../../../blueprints/i-blueprint";

export interface TimerState {
  name: string
  minutes: number
  seconds: number
}

export const initialState: TimerState = {
  name: "Timer",
  minutes: 5,
  seconds: 0
};

export function makeState(blueprint: TimerBlueprint) {
  let state = new InstanceState(
    blueprint.id, 
    timerActions, 
    TimerSelectors,
    TimerEffects,
    timerReducer,
    blueprint.stateServices,
    blueprint
  )
  return state
}
